import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const CalendarEventsPage = () => {
  // Calendar data for different years
  const calendarData = {
    "2017-2018": [
      { sno: 1, event: "26th Sub Junior National Baseball Championship", state: "Himachal Pradesh", month: "May 2017" },
      { sno: 2, event: "27th Junior National Baseball Championship", state: "Gujarat", month: "Sep 2017" },
      { sno: 3, event: "32th Senior National Baseball Championship", state: "Punjab", month: "Jan 2018" },
      { sno: 4, event: "Little league Baseball Championship", state: "Uttarakhand", month: "-" },
      { sno: 5, event: "Federation Cup", state: "Chandigarh", month: "Mar 2018" }
    ],
    "2018-2019": [
      { sno: 1, event: "27th Sub Junior National Baseball Championship", state: "Rajasthan", month: "Sept 2018" },
      { sno: 2, event: "28th Junior National Baseball Championship", state: "Telangana", month: "April 2019" },
      { sno: 3, event: "33th Senior National Baseball Championship", state: "Madhya Pradesh", month: "Jan 2019" }
    ],
    "2019-2020": [
      { sno: 1, event: "28th Sub Junior National Baseball Championship", state: "Assam", month: "July 19" },
      { sno: 2, event: "29th Junior National Baseball Championship", state: "Gujrat", month: "Jan 20" },
      { sno: 3, event: "34th Senior National Baseball Championship", state: "Andhra Pradesh", month: "Postpone due to COVID" }
    ],
    "2020-2021": [
      { sno: 1, event: "29th Sub Junior National Baseball Championship", state: "-", month: "to be announced" },
      { sno: 2, event: "30th Junior National Baseball Championship", state: "-", month: "to be announced" },
      { sno: 3, event: "34th Senior National Baseball Championship", state: "Andhra Pradesh", month: "29th March - 03rd April 2021" },
      { sno: 4, event: "15 Little League", state: "-", month: "to be announced" },
      { sno: 5, event: "11th Federation Cup", state: "-", month: "to be announced" }
    ],
    "2022-2023": [
      { sno: 1, event: "29th Sub Junior National Baseball Championship", state: "Punjab", month: "November, 2022" },
      { sno: 2, event: "30th Junior National Baseball Championship", state: "Kerala", month: "December, 2022" },
      { sno: 3, event: "35th Senior National Baseball Championship", state: "Punjab", month: "September, 2022" },
      { sno: 4, event: "15 Little League", state: "-", month: "-" },
      { sno: 5, event: "11th Federation Cup", state: "-", month: "-" }
    ]
  };

  useEffect(() => {
    document.title = 'Calendar Events | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/events">
          <div id="stick_right"></div>
        </Link>

        {/* Calendar Events Content */}
        <div id="basic">
          

          {Object.entries(calendarData).map(([year, events], yearIndex) => (
            <div key={year} style={{marginBottom: '30px'}}>
              <div className="panel panel-default">
                <div className="panel-heading" style={{textAlign: 'center'}}>
                  <h4 style={{margin: '10px 0', fontWeight: 'bold'}}>
                    Calendar of Events for the year {year}<br />
                    <span style={{fontSize: '14px'}}>SPORTS TOURNAMENT MANAGEMENT SYSTEM</span>
                  </h4>
                </div>
                <div className="panel-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Event</th>
                          <th>State</th>
                          <th>Month</th>
                        </tr>
                      </thead>
                      <tbody>
                        {events.map((event) => (
                          <tr key={event.sno}>
                            <td>{event.sno}</td>
                            <td>{event.event}</td>
                            <td>{event.state}</td>
                            <td>{event.month}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default CalendarEventsPage;